import { render } from "./DeviceForm.vue?vue&type=template&id=067784e9"
import script from "./DeviceForm.vue?vue&type=script&lang=js"
export * from "./DeviceForm.vue?vue&type=script&lang=js"
script.render = render

export default script